import React from 'react'
import SlotGamePopupGameCard from '../SlotGamePopupGameCard'

const SlotGamePopup = ({popupClose}) => {
    return (
        <>
            <section className='slot-game-popup fixed left-0 xl:left-[250px] right-0 bottom-0 top-0 bg-[#000c] z-[9998]'>
                <div className='slot-game-popup-container xl:max-w-[1200px] w-[90%] lg:w-full fixed lg:absolute left-1/2 lg:left-0 xl:left-1/2 top-[80px] bottom-[80px] overflow-y-auto ml-[-45%] lg:ml-0 xl:ml-[-600px] bg-obsidian border-[10px] border-slate '>
                    <button type="button" className='fixed top-auto lg:top-10 text-[40px] leading-[30px]'  onClick={popupClose}><i className='icofont icofont-close'></i></button>
                    <input type="text" name="slot_search" id="slot_search" placeholder="search" className='w-[70%] block bg-obsidian text-center mx-auto my-[5px] text-white text-xs leading-[36px] lg:leading-[33px] h-[36px] lg:h-[33px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-none lg:rounded-[5px] border border-slate placeholder:text-[#fff4cf] lg:placeholder:text-[#757575]' />
                    <div className='w-full p-2.5 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5'>
                        {Array.from({length:25}, (_,index)=>(
                        <SlotGamePopupGameCard  key={index}/>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default SlotGamePopup